export const DEFAULT_LANGUAGE = "fr";
export const DEFAULT_TIMEZONE = "America/Toronto";
